import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { formatRelativeTime, convertTagIdsToNames } from "@/lib/utils";
import { getStatusColor } from "@/lib/utils/statusColors";
import GlossaryWidget from "@/components/cards/widgets/ObjectsWidget";
import { DialogWizard } from "@/components/wizards/dialog/DialogWizard";
import { ItemTypeConfig } from "./types";

export const dialogsConfig: ItemTypeConfig = {
  type: "dialogs",
  title: "Conversation Dialogs",
  pageSection: "dialogs",
  eventName: "addDialog",
  emptyStateTitle: "No Dialogs",
  emptyStateDescription:
    "No conversation dialogs found for this game. Create your first dialog to get started.",
  noGameSelectedDescription: "Please select a game to view its dialogs.",

  transformData: (
    dialogs: any[],
    tags: any[],
    getUserNameById: (id: string) => string
  ): CardData[] => {
    if (!dialogs || !Array.isArray(dialogs)) {
      console.warn("transformData: dialogs is not an array:", dialogs);
      return [];
    }
    return dialogs.map((dialog) => {
      const statusColor = getStatusColor(dialog.status, 'dialogs', dialog.game_id);
      
      return {
        id: dialog.id,
        gameId: dialog.game_id,
        title: dialog.name,
        creator: "System",
        tags: convertTagIdsToNames(dialog.tags, tags),
        description: dialog.description || `Dialog Key: ${dialog.dialog_key}`,
        lastUpdate: formatRelativeTime(dialog.updated_at),
        version: 1.0,
        icon: "fa-comments",
        iconBg: "#6366F1",
        shadowType: dialog.status ? "status" : "black",
        shadowColor: statusColor,
        statusColor: statusColor,
        hasVersionMismatch: false,
        status: dialog.status,
        folder: dialog.folder,
        itemType: 'dialogs',
      };
    });
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <GlossaryWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        owner={card.owner}
        tags={card.tags}
        description={card.description}
        lastUpdate={card.lastUpdate}
        version={card.version}
        status={card.status}
        folder={card.folder as string}
        itemType="dialogs"
        icon={card.icon}
        iconBg={card.iconBg}
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        hasVersionMismatch={card.hasVersionMismatch}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => {
    return <DialogWizard {...props} />;
  },

  handleDelete: async (id: string, gameId: string, toast: any) => {
    // Handled by hook
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook
  },

  handleAdd: () => {
    // Handled by hook
  },
};

